<template>
  <el-dialog
    :title="model.id ? '编辑预警条件' : '添加预警条件'"
    :visible.sync="visible"
    width="660px"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="90px"
      size="small"
    >
      <el-form-item :label="labelTitle" prop="model_number">
        <el-input v-model="model.model_number"></el-input>
      </el-form-item>
      <el-form-item label="预警条件：">
        最近一次维修后
        <br />
        <el-input
          size="small"
          v-model.number="model.warning_current_day"
          style="width: 200px"
          ><template slot="prepend">寿命值达到</template
          ><template slot="append">天</template></el-input
        >
        <el-select
          size="small"
          v-model="model.warning_condition_type"
          placeholder=""
          style="width: 60px; margin: 0 5px"
        >
          <el-option key="1" :value="1" label="或"></el-option>
          <el-option key="2" :value="2" label="且"></el-option>
        </el-select>
        <el-input
          size="small"
          v-model.number="model.warning_current_hour"
          style="width: 240px"
          ><template slot="prepend">工作时长达到</template
          ><template slot="append">小时</template></el-input
        >
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  templateWarningRuleNew,
  templateWarningRuleUpdate,
} from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    labelTitle: String,
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      loading: false,
      rules: {
        model_number: [{ required: true, message: `请填写${this.labelTitle}` }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          if (this.model.id > 0) {
            let res = await templateWarningRuleUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await templateWarningRuleNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>